import React from "react";
import { useParams } from "react-router-dom";
import {API_AWARD, COLUMN_HEADER_KEYS} from "globals/constants";
import FormNotesView from "components/FormNotesView";
import { useFormAccesses } from "hooks";
import { getAward } from "store/actions/award";


const AwardNotesView = () => {
	const { awardId } = useParams();
	const formAccesses = useFormAccesses("award", awardId);

	const formInstance = {
		instanceId: awardId,
		endpoint: API_AWARD,
		type: COLUMN_HEADER_KEYS.AWARD
	};

	return (
		<FormNotesView
			formInstance = { formInstance }
			canAddNotes = { formAccesses.addContent }
			canEditNotes = { formAccesses.updateContent }
			refreshForm = { getAward }
		/>
	);
};

export default AwardNotesView;
